import "../../assets/css/results/streetview.css"

import { useEffect, useMemo, useState } from "react"
import Streetview from "react-google-streetview"
import Accordion from 'react-bootstrap/Accordion';
import { useAuth } from "../../context/auth-context";

import arrow from "../../assets/images/arrow_forward.svg"
import refresh from "../../assets/images/refresh.svg"
import dataTable from "../../assets/images/data_table.svg"
import bank from "../../assets/images/account_balance.svg"
import { STREETVIEW_LOCATIONS } from "./utils.js"

const googleMapsKey = process.env.REACT_APP_GOOGLE_MAP_KEY
export default function StreetviewMap(props) {
    const {
        activeStreetview,
        setActiveStreetview
    } = props
    
    const { user } = useAuth()
    
    const [show, setShow] = useState(false)
    const [currentLocation, setCurrentLocation] = useState(0)
    
    const [city, setCity] = useState(null)
    const [cityLocations, setCityLocations] = useState(null)


    const markers = useMemo(() => {
        if (!activeStreetview) return []

        const cityLocations = STREETVIEW_LOCATIONS.find(city => city.cityId === activeStreetview)
        setCityLocations(cityLocations)
        
        return cityLocations.groups?.reduce((acc, category) => {
            category.locations.forEach(place => {
                acc.push(place)
            })

            return acc
        }, [])
    }, [activeStreetview])
    
    const StreetMapOptions = useMemo(() => {
        return {
            position: { lat: markers?.length > 0 ? markers[currentLocation].latitude : 0, lng: markers?.length > 0 ? markers[currentLocation].longitude : 0 },
            pov: { heading: markers?.length > 0 ? markers[currentLocation].heading : 0, pitch: markers?.length > 0 ? markers[currentLocation].pitch : 0 },
            zoom: markers?.length > 0 ? markers[currentLocation].zoom : 0,
        };
    }, [markers, currentLocation])

    useEffect(() => {
        const gmIvAddressElements = document.querySelectorAll('.gm-iv-address');
        gmIvAddressElements.forEach(element => {
            element.style.opacity = false ? '1' : '0';
            element.style.visibility = false ? 'visible' : 'hidden';
        });
    }, []); //todo: agregar state para control de direccion
    
    useEffect(() => {
        if (!activeStreetview) return

        const selectedCity = user.selectedCities.find(city => city.datamexico_municipality_id === activeStreetview)

        setCity(selectedCity)
    }, [activeStreetview])

    

    function handleCurrentLocation(e) {
        const { id } = e.target
        e.stopPropagation()
        setShow(false)

        if(currentLocation === 0 && id === "prev") return setCurrentLocation(markers.length - 1)

        if(currentLocation === markers.length - 1 && id === "next") return setCurrentLocation(0)

        setCurrentLocation(prev => {
            if (id === "prev") return prev - 1

            return prev + 1
        })
    }

    function handleCloseStreetView() {
        setActiveStreetview(null)
        setCurrentLocation(0)
        setShow(false)
    }

    function handleRefresh() {
        setCurrentLocation(0)
        setShow(false)
    }

    function handleLocation(coordinates) {
        const index = markers.findIndex(marker => marker.longitude === coordinates[0] && marker.latitude === coordinates[1])
        setCurrentLocation(index)
        setShow(false)
    }

    if (!city) return null
    
    return (
        <div className={`streetviewContainer ${activeStreetview ? "show" : ""}`}>
            <div className="streetviewHeader">
                <div className="streetviewHeaderTitle">
                    <img src={arrow} alt="ProdensaAutomation" onClick={handleCloseStreetView}/>
                    <h5 className="tourTexts">{city ? city.municipality_name : "to be determined"}</h5>
                </div>
                <img className="refresh" src={refresh} alt="ProdensaAutomation" onClick={handleRefresh}/>
            </div>

            <Streetview
                apiKey={googleMapsKey}
                streetViewPanoramaOptions={StreetMapOptions}
            />

            <div className="tourLocationsMenu">
                <div className="tourLocationsHeader" onClick={() => setShow(!show)}>
                    <div className="headerContainer">
                        <img src={dataTable} alt="ProdensaAutomation"/>
                        <h5 className="tourTexts">Tour Locations</h5>
                    </div>
                    <div className="headerContainer">
                        <img id="prev" style={{transform: "rotate(180deg)"}} src={arrow} alt="ProdensaAutomation" onClick={handleCurrentLocation}/>
                        <p className="tourTexts">{currentLocation + 1}/{markers?.length}</p>
                        <img id="next" src={arrow} alt="ProdensaAutomation" onClick={handleCurrentLocation}/>
                    </div>
                </div>

                <div className={`tourLocationsList ${show ? "show" : ""}`}>
                    <Accordion>
                        {city && cityLocations.groups?.map(category => {
                            return(
                                <Accordion.Item eventKey={category.id} key={category.id}>
                                    <Accordion.Header>{<img src={bank} alt="Prodensa Automation" />}{category.title}</Accordion.Header>
                                    <Accordion.Body>
                                        <ul className="ul">
                                            {category.locations.map(place => (
                                                <li key={place.id} onClick={() => handleLocation([place.longitude, place.latitude])}>{place.title}</li>
                                            ))}
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>
                            )
                        })}
                    </Accordion>
                </div>
            </div>
        </div>
    )
}